import React, { Component } from "react";
import { PropTypes } from "prop-types";

import { LOGIN_ROUTE } from "../routes/routes";

class OauthFailure extends Component {
  componentDidMount() {
    setTimeout(() => {
      const url = LOGIN_ROUTE;
      window.opener.open(url, "_self");
      window.opener.focus();
      window.close();
    }, 5000);
  }

  render() {
    return <div>{this.props.match.params.message}</div>;
  }
}

OauthFailure.propTypes = {
  match: PropTypes.object.isRequired,
};

export default OauthFailure;
